export const REPORT_STATUSES = {
  notStarted: 'NOT_STARTED',
  generated: 'GENERATED',
  failed: 'FAILED',
  generating: 'GENERATING',
} as const
